import { render, staticRenderFns } from "./outline-button.vue?vue&type=template&id=7e648848"
import script from "./outline-button.vue?vue&type=script&lang=ts"
export * from "./outline-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButton: require('/vercel/path0/components/ui/button.vue').default})
